import Glyph from "@/components/Glyph";
import { ArrowLeft } from "lucide-react";
import SignSample from "@/components/SignSample";

export default function TrinityPreview({ preview, onBack }) {
  const t = preview.trinity;
  return (
    <div data-testid="trinity-preview">
      <button data-testid="btn-preview-back" onClick={onBack} className="flex items-center gap-1 text-sm gold-text mb-3">
        <ArrowLeft size={15} /> Change birth details
      </button>
      <div className="grid grid-cols-3 gap-2 mb-5">
        {[["Sun", t.sun], ["Moon", t.moon], ["Rising", t.rising]].map(([label, s]) => (
          <div key={label} data-testid={`preview-${label.toLowerCase()}`} className="bg-[#0F1523] border border-[#D4AF37]/25 rounded-2xl py-3 text-center">
            <p className="gold-text text-2xl leading-none"><Glyph ch={s.glyph} /></p>
            <p className="text-sm text-[#E8DCC4] mt-1">{s.sign}</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#6c7686]">{label}</p>
          </div>
        ))}
      </div>
      <SignSample r={preview.reading} prefix="preview-reading" />
    </div>
  );
}
